import { Card, CardContent, CardHeader } from './ui/card';

interface MessageScreenProps {
  heading?: string;
  title?: string;
  message: string;
}

export function MessageScreen({
  heading = 'Ops...',
  title,
  message,
}: MessageScreenProps) {
  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-background p-4">
      <Card className="flex w-full max-w-md flex-col items-center p-8 text-center">
        <CardHeader className="space-y-4 justify-center">
          <div className="text-6xl font-bold text-muted-foreground">
            {heading}
          </div>
        </CardHeader>

        <CardContent className="space-y-2">
          {title && (
            <h1 className="text-2xl font-semibold text-foreground">{title}</h1>
          )}
          <p className="text-muted-foreground">{message}</p>
        </CardContent>
      </Card>
    </div>
  );
}
